import React from 'react';
import { parseJSON } from '../../utils/helpers';
import ObjectViewer from '../Common/ObjectViewer';
import { Link } from 'react-router-dom';

const LogList = (props) => {
  const { logs, logType, setLogType, fetchLogs, loadingLogs, ruleId } = props;
  return (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center ' data-aos='fade-up' data-aos-delay='200'>
          <h1>Logs</h1>
        </div>
        {ruleId ? (
          <div
            className='col-lg-12 d-flex justify-content-center border-bottom'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            <small>Showing last {logs.length} logs</small>
          </div>
        ) : null}
        <div className='col-lg-12 d-flex justify-content-center mt-4' data-aos='fade-up' data-aos-delay='200'>
          <h6>
            Rule ID:{' '}
            <Link className='text-primary' to={`/rule/${ruleId}`}>
              {ruleId}
            </Link>
          </h6>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-3'>
        <h5>Logs Type</h5>
      </div>
      <div className='row d-flex justify-content-center mb-2'>
        <div className='col-md-8 d-flex justify-content-center'>
          <div className='btn-group'>
            <input
              type='text'
              className='form-control'
              defaultValue={logType}
              placeholder='Log Type...'
              onChange={(e) => setLogType(e.target.value)}
            />
            <button className='btn btn-success' disabled={loadingLogs} onClick={() => fetchLogs()}>
              {loadingLogs ? 'Loading...' : 'Search'}
            </button>
          </div>
        </div>
      </div>
      {logs.map((log) => {
        const data = parseJSON(log.jsonData);
        const createdAt = new Date(log.createdAt).toLocaleString();
        if (ruleId && data.rule?._id !== ruleId) {
          return null;
        }
        return (
          <div className='border p-2' key={log._id}>
            <div className='row d-flex justify-content-center pt-lg-0'>
              <div className='col-lg-12 d-flex justify-content-center pt-lg-0'>
                <h6 className='text-primary'>{log.logType}</h6>
              </div>
            </div>
            <div>
              <ObjectViewer data={data} />
            </div>
            <div className='row d-flex justify-content-center pt-lg-0'>
              <div className='col-lg-12 d-flex justify-content-center pt-lg-0 '>
                <h6>{createdAt}</h6>
              </div>
              <div className='col-lg-12 d-flex justify-content-center pt-lg-0 '>
                <Link to={`/log/${log._id}`}>More Details</Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LogList;
